require('./ecDeploy.style.scss');

const HELP_GENERAL = 'Deploy_ec';

let SELECT_VM_STATE_AZURE = "SELECT_VM_STATE_AZURE",
    VM_SETTINGS_STATE = "VM_SETTINGS_STATE";

class EcDeployControler {
    constructor($scope, $element, $q, $filter, $timeout, ecDeployPersistence, utilsService, dialogService, notificationService, validationsService, storageService) {
        this.$scope = $scope;
        this.ecDeployPersistence = ecDeployPersistence;
        this.$element = $element;
        this.$q = $q;
        this.$filter = $filter;
        this.$timeout = $timeout;
        this.utilsService = utilsService;
        this.dialogService = dialogService;
        this.validationsService = validationsService;
        this.notificationService = notificationService;
        this.storageService = storageService;
        this.noNetworks = false;
        this.vmAzureNamingPattern = this.validationsService.newvmName;
    }

    $onInit() {
        this.actionButton = [
            {
                title: this.$filter('translate')('toolbar.default.back.label'),
                action: () => this.actionBack(),
                isVisible: () => this.state === VM_SETTINGS_STATE,
                isDisabled: () => this.busy,
                btnClass: 'ctx-btn-secondary',
                id: 'ec-deploy-to-back'
            },
            {
                title: this.$filter('translate')('ec.deploy.button.deploy'),
                action: () => this.deploy(),
                isDisabled: () => this.isDeployDisabled(),
                isVisible: () => this.state === VM_SETTINGS_STATE,
                id: 'ec-deploy-to-restore'
            },
            {
                title: this.$filter('translate')('vm.restore.dialog.btn.next'),
                action: () => this.nextAction(),
                isDisabled: () => this.isNextDisabled(),
                isVisible: () => this.state === SELECT_VM_STATE_AZURE,
                id: 'ec-deploy-to-next'
            }
        ];
        let timeoutNC = null;

        this.networkTableConfig = [
            { name: this.$filter('translate')('ec.deploy.network.table.targetNetwork'), key: 'parentValue', isNetwork: true },
            { name: this.$filter('translate')('ec.deploy.network.table.type'), key: 'value' }];
        this.networkTableActionButtons = [
            { title: this.$filter('translate')('common.action.delete'), icon: 'icon-trash', action: this.removeNetwork.bind(this) },
            { title: this.$filter('translate')('toolbar.default.edit.label'), icon: 'icon-edit', action: this.editNetwork.bind(this) }
        ];

        this.$scope.$watch(() => this.numCpus, () => {
            if (this.state !== VM_SETTINGS_STATE) return;
            if (timeoutNC) clearTimeout(timeoutNC);
            timeoutNC = setTimeout(() => {
                this.getVmType();
            }, 500);
        });
        let timeoutSV = null;
        this.$scope.$watch(() => this.sizeValue, () => {
            if (this.state !== VM_SETTINGS_STATE) return;
            if (timeoutSV) clearTimeout(timeoutSV);
            timeoutSV = setTimeout(() => {
                this.getVmType();
            }, 500);
        });

        this.$scope.$watch(() => this.machineType, () => {
            if (!this.machineType) return;
            if (this.machineType.numberOfNetworks < this.networks.length) {
                this.networks = this.networks.slice(0, this.machineType.numberOfNetworks);
            }
        });
    }

    onOpen() {
        this.state = SELECT_VM_STATE_AZURE;
        this.modalTitle = this.$filter('translate')('ec.deploy.title');
        this.$timeout(() => {
            this.carouselIsVisible = true;
        }, 300);
        this.startIndex = 0;
        this.busy = true;
        this.ecDeployPersistence.getSubscriptions().then((res) => {
            this.subscriptionList = res.map((elem, i) => {
                return {
                    id: i,
                    label: elem.name,
                    value: elem.uuid,
                    managerEndpointUrl: elem.managerEndpointUrl
                };
            });;

            this.originalSubscriptionList = res.map((elem, i) => {
                return {
                    id: i,
                    label: elem.name,
                    value: elem.uuid,
                    managerEndpointUrl: elem.managerEndpointUrl
                };
            });;

            if (this.subscriptionList.length) {
                this.subscription = this.subscriptionList.filter(sub => sub.value === this.storageService.getSubscription().uuid)[0];
                this.onSubscriptionChanged();
            } else this.busy = false;
        });
        this.resourceGroupList = [];
        this.locationList = [];
        this.availabilityZoneList = [];
    }

    onSubscriptionChanged() {
        let promises = [], deffered_1, deffered_2;
        this.resourceGroupList = [];
        this.resourceGroup = null;
        this.locationList = [];
        this.networks = [];
        this.location = null;
        this.resetFormValue(this.dialogAzureSelectForm);

        // 1. GET resource groups
        deffered_1 = this.$q.defer();
        this.ecDeployPersistence.getResourceGroupsFromAzure(this.subscription.value).then((res) => {
            deffered_1.resolve(res);
            this.resourceGroupList = res;
            this.originalResourceGroupList = res;
        }).catch((error) => deffered_1.resolve(error));
        promises.push(deffered_1.promise);

        // 2. GET locations
        deffered_2 = this.$q.defer();
        this.ecDeployPersistence.getLocations(this.subscription.managerEndpointUrl, this.subscription.value).then((res) => {
            deffered_2.resolve(res);
            this.locationList = res.map((elem, i) => {
                return {
                    id: i,
                    label: elem.displayName + ' (' + elem.name + ')',
                    value: elem.uuid,
                    name: elem.name
                };
            });
            this.originalLocationList = res.map(elem => {
                return {
                    label: elem.displayName + ' (' + elem.name + ')',
                    name: elem.name,
                    value: elem.uuid
                };
            });
        }).catch((error) => deffered_2.resolve(error));
        promises.push(deffered_2.promise);

        this.busy = this.$q.all(promises).then(() => {
            this.busy = false;
        });
    }

    onResourceGroupChanged() {
        this.networks = [];
        if (this.location) {
            this.onLocationChanged();
        }
    }

    onLocationChanged() {
        this.networks = [];
        this.allNetworks = [];
        this.availabilityZone = null;
        if (this.resourceGroup) {
            let promises = [], deffered_1, deffered_2;

            // 2. GET networks
            deffered_1 = this.$q.defer();
            this.ecDeployPersistence.getVirtualNetworks(this.subscription.managerEndpointUrl, this.subscription.value, this.location.name).then((res) => {
                if (!res || !res.length) {
                    this.noNetworks = true;
                    this.deffered_1.resolve(res);
                    return;
                }

                this.noNetworks = false;
                this.allNetworks = res.map(item => {
                    item.label = item.name;
                    item.value = item.name;
                    item.isParent = true;
                    item.subnetsList = item.subnets.map((i, index) => {
                        return {
                            subnetId: index,
                            label: i,
                            value: i,
                            parentValue: item.value,
                            isChild: true,
                            isAdded: false,
                            resourceGroup: item.resourceGroup,
                            subscriptionUuid: item.subscriptionUuid,
                            location: item.location
                        };
                    });
                    return item;
                });
                if (!this.allNetworks[0] || !this.allNetworks[0].subnetsList || !this.allNetworks[0].subnetsList.length) {
                    this.deffered_1.resolve(res);
                    return;
                }

                let firstItem = this.allNetworks.filter(network => network.resourceGroup === this.resourceGroup.label)[0].subnetsList[0];
                if (firstItem) {
                    firstItem.isAdded = true;
                    this.networks.push({
                        id: this.networks.length,
                        subnetId: firstItem.subnetId,
                        value: firstItem.value,
                        parentValue: firstItem.parentValue,
                        resourceGroup: firstItem.resourceGroup,
                        subscriptionUuid: firstItem.subscriptionUuid,
                        location: firstItem.location,
                        ipConfiguration: {
                            privateIpRange: null,
                            privateIpType: "DYNAMIC",
                            publicIp: null,
                            publicIpType: "NONE"
                        }
                    });
                }
                this.deffered_1.resolve(res);
                return;
            }).catch((error) => deffered_1.resolve(error));
            promises.push(deffered_1.promise);

            deffered_2 = this.$q.defer();
            this.ecDeployPersistence.getAvailabilityZone(this.subscription.managerEndpointUrl, this.subscription.value, this.location.value).then((res) => {
                res.splice(0, 0, 'None');
                this.availabilityZoneList = res.map((elem, i) => {
                    return {
                        id: i,
                        label: elem,
                        value: elem
                    };
                });
                this.originalAvailabilityZoneList = res.map((elem, i) => {
                    return {
                        id: i,
                        label: elem,
                        value: elem
                    };
                });

                this.availabilityZone = this.availabilityZoneList[0];
            });
            this.busy = this.$q.all(promises).then(() => {
                this.busy = false;
            });
        }
    }

    openNetworkDialog(editMode, entry) {
        this.networkEditFlag = false;
        this.setAvailableNetworks(editMode, entry);

        if (!editMode) {
            this.showAzureNetworkModal = true;
        }
    }

    setAvailableNetworks(editMode, entry) {
        this.network = null;
        if (!this.networks.length) {
            this.allNetworks.forEach(net => {
                net.subnetsList.forEach(i => i.isAdded = false);
            });
            this.availableNetworks = this.allNetworks;
            return;
        }
        // Note: Azure VMs can only be connected to 1 virtual network
        // User can set list with different subnets, but network must be the same
        this.availableNetworks = this.allNetworks.filter(n => n.value === this.networks[0].parentValue);
    }

    editNetwork(entry) {
        this.openNetworkDialog(true, entry);
        this.networkEditFlag = true;
        this.network = entry;
        this.showAzureNetworkModal = true;
    }

    removeNetwork(entry) {
        return this.dialogService.showYesNo(
            this.$filter('translate')('ec.deploy.network.delete.message'), this.$filter('translate')('ec.deploy.network.delete.title'))
            .then(res => {
                if (res) {
                    this.networks = this.networks.filter(item => {
                        return entry.id !== item.id;
                    });
                    this.updateAllNetwork(entry.parentValue);
                }
            });
    }

    updateAllNetwork(parent) {
        if (this.networks.length) {
            let addedChildList = this.networks.map(i => i.value);
            let activeNet = this.allNetworks.filter(i => i.value === parent)[0];
            activeNet.subnetsList.forEach(i => {
                i.isAdded = addedChildList.indexOf(i.value) >= 0;
            });
        } else {
            this.allNetworks.forEach(i => {
                i.subnetsList.forEach(s => s.isAdded = false);
            });
        }
    }

    addNetwork(publicIpType, publicIp, privateIpType, privateIpRange, subnet) {
        return this.$q((resolve) => {
            this.$timeout(() => {
                this.addNetworkToList(publicIpType, publicIp, privateIpType, privateIpRange, subnet, this.networkEditFlag);
                resolve();
            }, 500);
        });
    }

    addNetworkToList(publicIpType, publicIp, privateIpType, privateIpRange, subnet, editMode) {
        if (!editMode) {
            this.networks.push({
                id: this.networks.length,
                subnetId: subnet.subnetId,
                value: subnet.value,
                parentValue: subnet.parentValue,
                resourceGroup: subnet.resourceGroup,
                subscriptionUuid: subnet.subscriptionUuid,
                location: subnet.location,
                subnetName: subnet.value,
                ipConfiguration: {
                    publicIpType: publicIpType,
                    publicIp: publicIp ? {
                        subscriptionUuid: publicIp.subscriptionUuid,
                        resourceGroup: publicIp.resourceGroup,
                        name: publicIp.value,
                    } : null,
                    privateIpType: privateIpType,
                    privateIpRange: privateIpRange
                }
            });
        } else {
            this.networks.forEach(net => {
                if (net.subnetId !== this.network.subnetId) return;
                net.id = net.id;
                net.subnetId = subnet.subnetId;
                net.value = subnet.value;
                net.parentValue = subnet.parentValue;
                net.resourceGroup = subnet.resourceGroup;
                net.subscriptionUuid = subnet.subscriptionUuid;
                net.location = subnet.location;
                net.subnetName = subnet.value;
                let ipConfigObj = {
                    publicIpType: publicIpType,
                    publicIp: publicIp ? {
                        subscriptionUuid: publicIp.subscriptionUuid,
                        resourceGroup: publicIp.resourceGroup,
                        name: publicIp.value,
                    } : null,
                    privateIpType: privateIpType,
                    privateIpRange: privateIpRange
                };
                net.ipConfiguration = ipConfigObj;
            });
        }
        this.network = null;
        // this.updateAllNetwork(subnet.parentValue);
    }

    getExternalAddresses(subscription) {
        return this.ecDeployPersistence.getExternalAddresses(subscription, this.location.name, this.availabilityZone.value);
    }


    searchResourceGroup() {
        if (!this.ecDeployPersistence.resourceGroupTableState) return;
        this.resourceGroupList = this.onCustomSearchBy(this.ecDeployPersistence.resourceGroupTableState.searchBy, this.originalResourceGroupList);
    }

    searchLocation() {
        if (!this.ecDeployPersistence.locationTableState) return;
        this.locationList = this.onCustomSearchBy(this.ecDeployPersistence.locationTableState.searchBy, this.originalLocationList);
    }

    searchAvailabilityZone() {
        if (!this.ecDeployPersistence.availabilityZoneTableState) return;
        this.availabilityZoneList = this.onCustomSearchBy(this.ecDeployPersistence.availabilityZoneTableState.searchBy, this.originalAvailabilityZoneList);
    }

    searchSubscription() {
        if (!this.ecDeployPersistence.subscriptionTableState) return;
        this.subscriptionList = this.onCustomSearchBy(this.ecDeployPersistence.subscriptionTableState.searchBy, this.originalSubscriptionList);
    }

    onCustomSearchBy(searchBy, originalList) {
        let list = [];
        let filteredList = searchBy !== '' ? originalList.filter(item => item.label.toLowerCase().indexOf(searchBy) !== -1) : originalList;
        filteredList.forEach(item => list.push(item));
        return list.map(i => i);
    }

    onTitleClick() {
        this.actionBack();
    }

    navigateTo(index) {
        this.navigationEvent = true;
        this.goToStep(index);
    }

    goToStep(index) {
        this.index = index;
        this.carousel.goTo(index);
    }

    nextAction() {
        let index = 1;
        this.navigateTo(index);
    }

    actionBack() {
        let index = 0;
        this.setVisible = false;
        this.ecDeployPersistence.resourceGroupTableState.searchBy = '';
        this.ecDeployPersistence.locationTableState.searchBy = '';
        this.ecDeployPersistence.subscriptionTableState.searchBy = '';
        this.ecDeployPersistence.availabilityZoneTableState.searchBy = '';
        this.navigateTo(index);
    }

    isNextDisabled() {
        return this.busy || ((this.dialogAzureSelectForm && !this.dialogAzureSelectForm.$valid) || (!this.resourceGroup && !this.location)) || this.noNetworks;
    }

    isDeployDisabled() {
        return this.busy || (this.dialogVmSpecForm && !this.dialogVmSpecForm.$valid) || (!this.networks.length === 0);
    }

    setCarousel(carousel) {
        this.carousel = carousel;
        this.index = 0;
        this.state = SELECT_VM_STATE_AZURE;
    }

    onChange(index) {
        if (!this.navigationEvent) {
            this.index = index;
        }
        if (this.index === 0) {
            this.resetFormValue(this.dialogAzureSelectForm);
            this.state = SELECT_VM_STATE_AZURE;
            this.helpId = HELP_GENERAL;
            this.modalTitle = this.customTitle ? this.customTitle : this.$filter('translate')('ec.deploy.title');
            this.machineType = null;
            this.machineTypeList = [];
            let tempSizeValue = 7;
            this.sizeValue = !tempSizeValue || tempSizeValue < 1 ? 1 : Math.ceil(tempSizeValue);
            this.numCpus = 4;
            // this.modalSubTitle = (' » ') + this.$filter('translate')('vm.restore.options.restoreVMToAzure.title');
        }
        if (this.index === 1) {
            this.state = VM_SETTINGS_STATE;
            this.modalSubTitle = (' » ') + this.$filter('translate')('ec.deploy.subtitle');
            this.utilsService.focusOnElement(this.$element.find('#vmName'), true);
            this.resetFormValue(this.dialogVmSpecForm);
            this.getVmType();
        }
    }

    getVmType() {
        this.machineType = null;
        this.machineTypeList = [];
        if (!this.isMemorySizeValid() || !this.isCpuValid()) return;
        let data = null;


        data = {
            subscriptionId: this.subscription.value,
            resourceGroupId: this.resourceGroup.value,
            locationId: this.location.value,
            managerUrl: this.subscription.managerEndpointUrl,
            // in case that uefi_boot parameter is not set or is set to false, bootType should be set to 'BIOS'
            // in case that uefi_boot parameter is set to true, bootType should be set to 'UEFI'
            params: {
                bootType: this.metadata && this.metadata.boot && this.metadata.boot.uefi_boot ? 'UEFI' : 'BIOS',
                numCpus: this.numCpus,
                memorySizeGb: this.sizeValue,
                minDataDisks: 1
            }
        };
        if (this.availabilityZone && this.availabilityZone.value !== 'None') {
            data.availabilityZone = this.availabilityZone.value;
        }

        this.busy = this.ecDeployPersistence.getVMType(data).then((res) => {
            this.machineTypeList = res.map((item, i) => {
                return {
                    id: i,
                    label: item.description,
                    name: item.name,
                    memorySizeGb: item.memorySizeGb,
                    numberOfCpus: item.numberOfCpus,
                    numberOfNetworks: item.numberOfNetworkInterfaces,
                    value: item.name + '_' + item.memorySizeGb + '_' + item.numberOfCpus
                };
            });
            if (this.machineTypeList && this.machineTypeList.length > 0) this.machineType = this.machineTypeList[0];
        }).finally(() => this.busy = false);
    }

    isMemorySizeValid() {
        return this.sizeValue && this.sizeValue >= 1 && this.sizeValue <= 4096 ? Number.isInteger(this.sizeValue) : false;
    }

    isCpuValid() {
        return this.numCpus && this.numCpus >= 1 && this.numCpus <= 1024 ? Number.isInteger(this.numCpus) : false;
    }

    resetFormValue(form) {
        form.$setUntouched();
        form.$setPristine();
    }

    deploy() {
        let data = {};
        let subnets = [];
        this.networks.forEach(network => {
            subnets.push(network.value);
        });
        data.location = this.location.value;
        data.name = this.vmName;
        data.machineType = this.machineType.name;
        data.virtualNetwork = {
            name: this.networks[0].parentValue,
            subscriptionUuid: this.networks[0].subscriptionUuid,
            resourceGroup: this.networks[0].resourceGroup,
            location: this.networks[0].location,
            networkInterfaces: this.networks.map((network) => {
                return {
                    subnetName: network.value,
                    ipConfiguration: network.ipConfiguration
                };
            })
        };
        data.zones = !this.availabilityZone ? undefined : this.availabilityZone.value === 'None' ? [] : [this.availabilityZone.value];

        this.ecDeployPersistence.startDeploy(this.subscription.managerEndpointUrl, this.subscription.value, this.resourceGroup.value, data).then((res) => {
            this.notificationService.pop(res.data.message);
            this.showModal = false;
        });
    }

    onClose() {
        if (this.ecDeployPersistence.resourceGroupTableState) {
            this.ecDeployPersistence.resourceGroupTableState.searchBy = '';
        }

        if (this.ecDeployPersistence.locationTableState) {
            this.ecDeployPersistence.locationTableState.searchBy = '';
        }

        if (this.ecDeployPersistence.subscriptionTableState) {
            this.ecDeployPersistence.subscriptionTableState.searchBy = '';
        }

        if (this.ecDeployPersistence.availabilityZoneTableState) {
            this.ecDeployPersistence.availabilityZoneTableState.searchBy = '';
        }
    }

}

EcDeployControler.$inject = ['$scope', '$element', '$q', '$filter', '$timeout', 'ecDeployPersistence', 'utilsService', 'dialogService', 'notificationService', 'validationsService', 'storageService'];

const ecDeployComponent = {
    controller: EcDeployControler,
    template: require('./ecDeploy.template.html'),
    bindings: {
        showModal: "="
    }
};

module.exports = ecDeployComponent;


// WEBPACK FOOTER //
// ./src/azurebackup/views/mainApp/dialogs/ecDeploy/ecDeploy.component.js